// extracted by mini-css-extract-plugin
module.exports = {"heart":"Heart_heart__3ShIv","lottie":"Heart_lottie__2HT5J","heartTip":"Heart_heartTip__1N-yQ"};